<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <section>
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="6" class="padding-ten-tb float-left">
          <h5 class="title__name">Creación OS</h5>
        </b-col>
      </b-row>
    </section>
    <section>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="5" class="section__center-col">
          <p class="section__title section__margin-two-bottom">
            Seleccione el método de ingreso de datos
          </p>
          <b-button
            v-if="optionCreacionNV"
            :to="{ name: 'NotaVenta' }"
            block
            class="section__button_rounded"
          >
            Nota de Venta
          </b-button>
          <b-button
            v-if="optionCreacionManual"
            :to="{ name: 'Manual' }"
            block
            class="section__button_rounded"
          >
            Manual
          </b-button>
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "CreacionOs",
  data() {
    return {};
  },

  computed: {
    ...mapState("module", ["options"]),
    optionCreacionManual() {
      //id 3 Crear Manual
      return this.options.some((m) => m.id == 3);
    },
    optionCreacionNV() {
      //id 3 Crear Nota Venta
      return this.options.some((m) => m.id == 4);
    },
  },
  methods: {},
};
</script>
<style scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: white !important;
}

.border-right-none {
  border-right: none;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}
::v-deep .modal-header {
  border-bottom: none !important;
}
::v-deep #modal-pending .modal-header {
  display: none;
}

::v-deep #modal-pending .modal-footer {
  align-items: center;
}
::v-deep #modal-pending .modal-footer button {
  background: orange;
}
::v-deep .modal-footer {
  justify-content: center;
}

.padding-bottom-none {
  margin-bottom: 0 !important;
}
::v-deep .btn-sm {
  border-radius: 20px;
}
.text-orange {
  color: #ff7a00;
}

.paddding-two-bottom {
  padding-bottom: 15px;
}

::-webkit-input-placeholder {
  text-align: left;
}

:-moz-placeholder {
  /* Firefox 18- */
  text-align: left;
}

::-moz-placeholder {
  /* Firefox 19+ */
  text-align: left;
}

:-ms-input-placeholder {
  text-align: left;
}
.bg-orange {
  border-color: transparent;
  background: rgb(254, 123, 1) !important;
  border-radius: 20px;
}
.input-group-text {
  border-left: none;
  background-color: #ffffff;
}
.font {
  display: inline-block;
  width: 100%;
}
::v-deep .b-table thead {
  background: rgb(254, 123, 1);
  color: white;
  font-weight: 400 !important;
}
::v-deep .b-table thead th {
  font-weight: 400 !important;
}
.padding-ten-lr {
  padding: 10px;
  padding-left: 30px !important;
}

.color-gray {
  color: #676767;
  font-weight: bold;
}
.text-grey {
  color: #676767;
  font-size: 15px;
  letter-spacing: 0px;
  display: block;
}

.btn-secondary:focus {
  box-shadow: none;
}
.btn-secondary:active {
  box-shadow: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}
@media (max-width: 575.98px) {
  .padding-six-top-xs {
    padding-top: 5%;
  }
  .width-auto-xs {
    width: 100%;
    text-align: center;
  }
}
</style>
